import React from 'react';
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import Carousel from '../carousel/carousel';
import HomeIcon from '../common/HomeIcon';

class Mantra_5_A1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
            nav3: null
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
            nav3: this.slider3
        });
    }

    render() {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            initialSlide: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            responsiveMode: true,
            focusOnSelect: true,
        };
        return (
            <>

                {/* <img src="/assets/img/home.png" className="img-fluid home_img" alt="" /> */}
                <HomeIcon />

                <div className="slider_m5_wrp ">
                    <div className="slide_sl">
                        <Slider {...settings}
                            asNavFor={this.state.nav2}
                            asNavFor={this.state.nav3}
                            ref={slider => (this.slider1 = slider)}
                        >
                            <div className="m5_slide_wrp">
                                <img src="/assets/img/svg/tagore.svg" />
                            </div>
                            <div className="m5_slide_wrp m5_center_img">
                                <img src="/assets/img/svg/kalam.svg" />
                            </div>
                            <div className="m5_slide_wrp">
                                <img src="/assets/img/svg/cv-raman.svg" />
                            </div>
                        </Slider>
                    </div>
                    <div className="slide_sl slider_sec">
                        <Slider initialSlide={1}
                            asNavFor={this.state.nav1}
                            asNavFor={this.state.nav2}
                            ref={slider => (this.slider3 = slider)}
                            slidesToShow={1}
                            swipeToSlide={true}
                            focusOnSelect={true}
                        >
                            <div className="m5_ins_wrp">
                                <h4 className="m5_slider_txt1">A Tribute to</h4>
                                <h4 className="m5_slider_txt2"> Rabindranath Tagore</h4>
                            </div>
                            <div className="m5_ins_wrp">
                                <h4 className="m5_slider_txt1">The Inspirational</h4>
                                <h4 className="m5_slider_txt2">Dr. APJ Abdul Kalam</h4>
                            </div>
                            <div className="m5_ins_wrp">
                                <h4 className="m5_slider_txt1">An Inspirational Mathemagician</h4>
                                <h4 className="m5_slider_txt2">Sir CV Raman</h4>
                            </div>

                        </Slider>
                    </div>

                </div>
                <div className="container">
                    <div className="slide_sl slider_sec">
                        <Slider
                            initialSlide={1}
                            asNavFor={this.state.nav1}
                            ref={slider => (this.slider2 = slider)}
                            slidesToShow={1}
                            swipeToSlide={true}
                            focusOnSelect={true}
                        >

                            <div className="m5_para">
                                <p>Gurudev Rabindranath Tagore’s knowledge and intellect left an indelible mark on everyone. He was extremely talented but along with it, there was always a teacher in him that everyone could learn from. He wrote in Gitanjali, “He who has the knowledge has the responsibility to impart it to the students.”
<br/><br/>I do not know Bangla but I had the habit of rising early since my childhood. I have a faint memory, that probably around 5:30 AM, Rabindra Sangeet used to be broadcast on radio and I used to listen to it. And, whenever I got a chance to listen to poems like Anandaloke And Aguner Parashmoni, I used to feel energised.
<br/><br/>Gurudev Tagore manifested the best of India’s ethos of learning and expressing. A multifaceted personality, his prose, poetry and artwork are brilliant and thought provoking. He enhanced India’s pride and also contributed to the freedom movement.</p>
                            </div>
                            <div className="m5_para">
                                <p>Dr APJ Abdul Kalam made an indelible contribution towards national development, be it as a scientist or as the President of India.<br/><br/>
Dr Kalam was a ‘Rashtra Ratna’ even before he became a ‘Rashtrapati’ – he touched great heights in serving the nation even before he became the President of India. 
When asked how he should be remembered, Dr Kalam used to say that he wants to be remembered as a teacher.<br/><br/>
His commitment to teaching was also seen in his actions immediately after he finished serving his term as President. Just a few days after serving the nation in such an important role, he was seen in the classroom, teaching students. This was the kind of commitment he had.
Dr Kalam was a rare gem who strengthened India both through Shastra (weapons) and Shaastra (knowledge).</p>
                            </div>
                            <div className="m5_para">
                                <p>All of us have seen that the sea appears blue, but we know from routine life experiences that water has no colour at all. Have we ever thought why water acquires colour in rivers and seas? This thought occurred to a young man in the 1920s and gave rise to a great scientist of modern India. <br/><br/>
When we talk about science, the first name that strikes us is that of Bharat Ratna Sir CV Raman. He was awarded the Nobel Prize for his outstanding work on light scattering, often called Raman Effect.<br/><br/>
Our nation celebrates the 28th of February as National Science Day since on this very day, he is said to have discovered the phenomenon of light scattering, for which the Nobel Prize was conferred upon him.
Sir CV Raman’s pioneering contribution to science continues to inspire generations of science enthusiasts.</p>
                            </div>

                        </Slider>
                    </div>

                </div>
            </>
        )
    }
}

export default Mantra_5_A1;